module.exports = __webpack_public_path__ + "static/img/7.c05d90f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/zh/7.png
// module id = Y5xM
// module chunks = 0